export const GET_PREDICTED_SCORE_REQ = "GET_PREDICTED_SCORE_REQ";
export const GET_PREDICTED_SCORE_SUCCESS = "GET_PREDICTED_SCORE_SUCCESS";
export const GET_PREDICTED_SCORE_FAILED = "GET_PREDICTED_SCORE_FAILED";

export const GET_TARGET_SCORE_REQ = "GET_TARGET_SCORE_REQ";
export const GET_TARGET_SCORE_SUCCESS = "GET_TARGET_SCORE_SUCCESS";
export const GET_TARGET_SCORE_FAILED = "GET_TARGET_SCORE_FAILED";
